// src/components/Layout.js
import React, { useEffect } from "react";
import Header from "./Layout/Header";
import Footer from "./Layout/Footer";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkLoggedIn, setSingleUser } from "../redux/reducers/AuthSlice";

const Layout = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.authUser);
  
  const hiddenPaths = ["/login", "/register"];
  
  // Check authentication status on app load
  useEffect(() => {
    const token = localStorage.getItem('userAccess');
    if (token) {
      dispatch(checkLoggedIn(true));
      
      // Restore user data from localStorage if available
      try {
        const storedUserData = localStorage.getItem('userData');
        if (storedUserData) {
          const userData = JSON.parse(storedUserData);
          dispatch(setSingleUser(userData));
        }
      } catch (error) {
        // If user data is corrupted, clear it
        localStorage.removeItem('userData');
      }
    } else {
      dispatch(checkLoggedIn(false));
    }
  }, [dispatch]);
  
  return (
    <>
      <Header />
      <main className="main-wrapper">{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
